module.exports = __webpack_public_path__ + "static/media/Week 2 Thursday.1c886042.png";